var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "div",
        { staticClass: "header" },
        [
          _c("van-icon", {
            staticClass: "header-return",
            attrs: { name: "arrow-left", size: "25", color: "#ffffff" },
            on: {
              click: function($event) {
                return _vm.onClickHeaderReturn()
              }
            }
          }),
          _vm._v("\n    Temperature Setting\n    "),
          _c(
            "div",
            { staticClass: "header-save", on: { click: _vm.onClickSave } },
            [_vm._v("Save")]
          )
        ],
        1
      ),
      _c("div", { staticClass: "content" }, [
        _c("div", { staticClass: "my-voltage" }, [
          _vm._m(0),
          _c(
            "div",
            { staticClass: "my-voltage-content" },
            _vm._l(_vm.selectVoltage, function(item, index) {
              return _c(
                "div",
                { key: item.id, staticClass: "my-voltage-item" },
                [
                  _c("span", [_vm._v(_vm._s(item.modeName))]),
                  _c("img", {
                    attrs: { src: require("@/assets/icons/icon_close.png") },
                    on: {
                      click: function($event) {
                        return _vm.onClickDeleteMyVoltage(index)
                      }
                    }
                  })
                ]
              )
            }),
            0
          )
        ]),
        _c(
          "div",
          { staticClass: "voltage-setting" },
          [
            _c(
              "van-tabs",
              {
                staticClass: "voltage-tabs",
                attrs: {
                  animated: "",
                  swipeable: "",
                  color: "#6649C4",
                  "line-width": "140px",
                  "line-height": "6px",
                  background: "#FFFFFF",
                  "title-inactive-color": "#999999",
                  "title-active-color": "#6649c4"
                },
                model: {
                  value: _vm.activeSetting,
                  callback: function($$v) {
                    _vm.activeSetting = $$v
                  },
                  expression: "activeSetting"
                }
              },
              [
                _c(
                  "van-tab",
                  { attrs: { title: "My Settings", name: "mySettings" } },
                  [
                    _vm.mySettingList.length > 0
                      ? _c(
                          "div",
                          { staticClass: "my-setting" },
                          [
                            _c(
                              "div",
                              { staticClass: "my-setting-header" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "header-left",
                                    on: { click: _vm.onClickCreateMySetting }
                                  },
                                  [
                                    _c("img", {
                                      attrs: {
                                        src: require("@/assets/icons/icon_create.png")
                                      }
                                    }),
                                    _vm._v(
                                      "\n                Create\n              "
                                    )
                                  ]
                                ),
                                _vm.filterList2.length > 0
                                  ? _c("van-popover", {
                                      attrs: {
                                        trigger: "click",
                                        placement: "bottom-end",
                                        actions: _vm.filterList2,
                                        "get-container": _vm.getContainer2,
                                        "close-on-click-action": true,
                                        offset: [-1, 8]
                                      },
                                      on: { select: _vm.onSelectFilter },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "reference",
                                            fn: function() {
                                              return [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "my-setting-header-filter",
                                                    style:
                                                      _vm.selectFilter2 != ""
                                                        ? "color:#6649c4"
                                                        : "color:#999999"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                    Filter\n                    "
                                                    ),
                                                    _c("img", {
                                                      attrs: {
                                                        src:
                                                          _vm.selectFilter2 !=
                                                          ""
                                                            ? require("@/assets/icons/icon_filter_select.png")
                                                            : require("@/assets/icons/icon_filter.png")
                                                      }
                                                    })
                                                  ]
                                                )
                                              ]
                                            },
                                            proxy: true
                                          }
                                        ],
                                        null,
                                        false,
                                        1562844586
                                      ),
                                      model: {
                                        value: _vm.showFilterPopover2,
                                        callback: function($$v) {
                                          _vm.showFilterPopover2 = $$v
                                        },
                                        expression: "showFilterPopover2"
                                      }
                                    })
                                  : _vm._e()
                              ],
                              1
                            ),
                            _c(
                              "van-list",
                              {
                                staticClass: "my-setting-list",
                                attrs: {
                                  finished: _vm.finished_tab2,
                                  "finished-text": "No more data",
                                  "loading-text": "Loading more...",
                                  "error-text": "Request network error.",
                                  error: _vm.load_error_tab2,
                                  "immediate-check": false
                                },
                                on: {
                                  "update:error": function($event) {
                                    _vm.load_error_tab2 = $event
                                  },
                                  load: _vm.onLoadTab2
                                },
                                model: {
                                  value: _vm.loading_tab2,
                                  callback: function($$v) {
                                    _vm.loading_tab2 = $$v
                                  },
                                  expression: "loading_tab2"
                                }
                              },
                              _vm._l(_vm.mySettingList, function(item, index) {
                                return _c(
                                  "div",
                                  {
                                    key: item.id,
                                    staticClass: "my-setting-item"
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "my-setting-item-left" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "item-left-title",
                                            style:
                                              item.flavorName == null ||
                                              item.flavorName == ""
                                                ? "margin-bottom:5px;"
                                                : "margin-bottom:0px;"
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(item.modeName) +
                                                "\n                    "
                                            ),
                                            _c("img", {
                                              attrs: {
                                                src: require("@/assets/icons/icon_edit.png")
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.onClickEditVoltage(
                                                    item.id
                                                  )
                                                }
                                              }
                                            }),
                                            _c("img", {
                                              attrs: {
                                                src: require("@/assets/icons/icon_delete.png")
                                              },
                                              on: {
                                                click: function($event) {
                                                  _vm.showDeletePopup = true
                                                  _vm.deleteIndex = index
                                                }
                                              }
                                            })
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "item-left-label-list",
                                            style:
                                              item.flavorName != null &&
                                              item.flavorName != ""
                                                ? "margin-top:5px;"
                                                : "margin-top:0px;"
                                          },
                                          _vm._l(item.flavorName, function(
                                            label,
                                            index1
                                          ) {
                                            return _c(
                                              "div",
                                              {
                                                key: index1,
                                                staticClass: "item-left-label"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(label) +
                                                    "\n                    "
                                                )
                                              ]
                                            )
                                          }),
                                          0
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "item-left-msg",
                                            style:
                                              item.description != null &&
                                              item.description != ""
                                                ? "margin-top:5px;"
                                                : "margin-top:0px;"
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(item.description) +
                                                "\n                  "
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "my-setting-item-right" },
                                      [
                                        _c(
                                          "van-button",
                                          {
                                            class: item.checked
                                              ? "button-cancel"
                                              : "button-use",
                                            attrs: { type: "default" },
                                            on: {
                                              click: function($event) {
                                                return _vm.onClickApply(
                                                  index,
                                                  item.checked,
                                                  "mySettingsList"
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                item.checked ? "Cancel" : "Use"
                                              )
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                )
                              }),
                              0
                            )
                          ],
                          1
                        )
                      : _c("div", { staticClass: "my-setting" }, [
                          _c(
                            "div",
                            { staticClass: "my-setting-no-setting" },
                            [
                              _vm._v(
                                "\n              There is no setting\n              "
                              ),
                              _c(
                                "van-button",
                                {
                                  staticClass: "no-setting-create-button",
                                  attrs: { type: "default" },
                                  on: { click: _vm.onClickCreateMySetting }
                                },
                                [
                                  _vm._v(
                                    "\n                Create one\n              "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ])
                  ]
                ),
                _c(
                  "van-tab",
                  { attrs: { title: "Recommended", name: "recommended" } },
                  [
                    _vm.recommendedList.length > 0
                      ? _c(
                          "div",
                          { staticClass: "recommended" },
                          [
                            _c(
                              "div",
                              { staticClass: "recommended-header" },
                              [
                                _vm._v("\n              Hot\n              "),
                                _vm.filterList.length > 0
                                  ? _c("van-popover", {
                                      attrs: {
                                        trigger: "click",
                                        placement: "bottom-end",
                                        actions: _vm.filterList,
                                        "get-container": _vm.getContainer,
                                        "close-on-click-action": true
                                      },
                                      on: { select: _vm.onSelectFilter },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "reference",
                                            fn: function() {
                                              return [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "recommended-header-filter",
                                                    style:
                                                      _vm.selectFilter != ""
                                                        ? "color:#6649c4"
                                                        : "color:#999999"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                    Filter\n                    "
                                                    ),
                                                    _c("img", {
                                                      attrs: {
                                                        src:
                                                          _vm.selectFilter != ""
                                                            ? require("@/assets/icons/icon_filter_select.png")
                                                            : require("@/assets/icons/icon_filter.png")
                                                      }
                                                    })
                                                  ]
                                                )
                                              ]
                                            },
                                            proxy: true
                                          }
                                        ],
                                        null,
                                        false,
                                        3195402224
                                      ),
                                      model: {
                                        value: _vm.showFilterPopover,
                                        callback: function($$v) {
                                          _vm.showFilterPopover = $$v
                                        },
                                        expression: "showFilterPopover"
                                      }
                                    })
                                  : _vm._e()
                              ],
                              1
                            ),
                            _c(
                              "van-list",
                              {
                                staticClass: "recommended-list",
                                attrs: {
                                  finished: _vm.finished_tab1,
                                  "finished-text": "No more data",
                                  "loading-text": "Loading more...",
                                  "error-text": "Request network error.",
                                  error: _vm.load_error_tab1,
                                  "immediate-check": false
                                },
                                on: {
                                  "update:error": function($event) {
                                    _vm.load_error_tab1 = $event
                                  },
                                  load: _vm.onLoadTab1
                                },
                                model: {
                                  value: _vm.loading_tab1,
                                  callback: function($$v) {
                                    _vm.loading_tab1 = $$v
                                  },
                                  expression: "loading_tab1"
                                }
                              },
                              _vm._l(_vm.recommendedList, function(
                                item,
                                index
                              ) {
                                return _c(
                                  "div",
                                  {
                                    key: index,
                                    staticClass: "recommended-item"
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "recommended-item-left" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "item-left-title",
                                            style:
                                              item.flavorName == null ||
                                              item.flavorName == ""
                                                ? "margin-bottom:5px;"
                                                : "margin-bottom:0px;"
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(item.modeName) +
                                                "\n                  "
                                            )
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "item-left-label-list",
                                            style:
                                              item.flavorName != null &&
                                              item.flavorName != ""
                                                ? "margin-top:5px;"
                                                : "margin-top:0px;"
                                          },
                                          _vm._l(item.flavorName, function(
                                            label,
                                            index1
                                          ) {
                                            return _c(
                                              "div",
                                              {
                                                key: index1,
                                                staticClass: "item-left-label"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(label) +
                                                    "\n                    "
                                                )
                                              ]
                                            )
                                          }),
                                          0
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "item-left-msg",
                                            style:
                                              item.description != null &&
                                              item.description != ""
                                                ? "margin-top:5px;"
                                                : "margin-top:0px;"
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(item.description) +
                                                "\n                  "
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "recommended-item-right" },
                                      [
                                        _c(
                                          "van-button",
                                          {
                                            class: item.checked
                                              ? "button-cancel"
                                              : "button-use",
                                            attrs: { type: "default" },
                                            on: {
                                              click: function($event) {
                                                return _vm.onClickApply(
                                                  index,
                                                  item.checked,
                                                  "recommendedList"
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                item.checked ? "Cancel" : "Use"
                                              )
                                            )
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "item-right-msg" },
                                          [
                                            _vm._v(
                                              _vm._s(item.useCount) + " used"
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                )
                              }),
                              0
                            )
                          ],
                          1
                        )
                      : _c("div", { staticClass: "recommended" }, [
                          _c("div", { staticClass: "my-setting-no-setting" }, [
                            _vm._v(
                              "\n              No recommendation yet\n            "
                            )
                          ])
                        ])
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _c(
        "van-popup",
        {
          staticClass: "save-popup",
          style: { width: "88%" },
          attrs: { round: "", "close-on-click-overlay": false },
          model: {
            value: _vm.showDeletePopup,
            callback: function($$v) {
              _vm.showDeletePopup = $$v
            },
            expression: "showDeletePopup"
          }
        },
        [
          _c("div", { staticClass: "save-header" }, [_vm._v("Tips")]),
          _c("div", { staticClass: "save-content" }, [
            _c("div", { staticClass: "save-content-msg" }, [
              _vm._v("\n        Are you sure to delete it?\n      ")
            ]),
            _c("div", { staticClass: "save-footer" }, [
              _c(
                "button",
                {
                  directives: [{ name: "waves", rawName: "v-waves" }],
                  staticClass: "save-footer-cancel",
                  on: {
                    click: function($event) {
                      _vm.showDeletePopup = false
                    }
                  }
                },
                [_vm._v("\n          Cancel\n        ")]
              ),
              _c(
                "button",
                {
                  directives: [{ name: "waves", rawName: "v-waves" }],
                  staticClass: "save-footer-sure",
                  on: { click: _vm.onClickDeleteSure }
                },
                [_vm._v("\n          Sure\n        ")]
              )
            ])
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "my-voltage-title" }, [
      _vm._v("\n        My Voltage Curves\n        "),
      _c("span", { staticStyle: { color: "#999999" } }, [
        _vm._v("（Up to five）")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }